module.exports = __webpack_public_path__ + "static/media/face-add.4c3b2fac.svg";